import { manager1 } from '@/mocks/data/park/managers/list'

import { User } from '@/types/user'

export const user: User = {
    id: 70,
    first_name: 'test',
    last_name: 'TEST',
    email: 'test@test.test',
    origin_of_creation: 'KONVIVES',
    creation_date: '2023-01-12T14:18:24.056853Z',
    fidelity_point: 0,
    credit: 54.99,
    id_badge: null,
    max_number_discount: 0,
    phone: '06 75 38 70 35',
    nb_discount_used: 0,
    card_id: null,
    activation_key: null,
    activation_key_expires: null,
    avatar: null,
    receive_newsletter: true,
    receive_discount: true,
    receive_publicity: true,
    pspReference: 'buy_7931529690c140efa6f36f7aa3114c2c',
    recurringDetailReference: null,
    reset_password_code: null,
    reset_password_code_expires_at: null,
    automatic_payment_threshold: null,
    site_customer: null,
    service: null,
    client: manager1,
}
